import React from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { tableIcons } from "./Tableicons";
import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Typography,
  Paper,
  Divider,
} from "@material-ui/core";
const styles = (theme: Theme) =>
  createStyles({
    chip: {
      margin: theme.spacing(0.5),
    },
  });

interface Props extends WithStyles<typeof styles> {
  title: any;
  columns: any;
  data: any;
  onAddDataChanged: any;
  onEditDataChanged: any;
  onDeleteataChanged: any;
  customDeleteObject?: any;
}

class EditableTableComponent extends React.Component<Props> {
  state = {
    columns: new Array<any>(),
    data: new Array<any>(),
    openConfirmationDialog: false,
    rowData: {},
  };
  componentDidMount = () => {
    const { columns, data } = this.props;
    this.setState({ data: data, columns: columns });
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps.data !== this.props.data) {
      const { columns, data } = this.props;
      this.setState({ data: data, columns: columns });
    }
  };

  handleClose = () => {
    this.setState({
      openConfirmationDialog: false,
    });
  };

  handleOnConrimDelete = () => {
    const { onDeleteataChanged } = this.props;
    this.handleClose();
    onDeleteataChanged(this.state.rowData);
  };

  renderConfirmDialog = () => {
    const { customDeleteObject } = this.props;
    return (
      <Dialog
        open={this.state.openConfirmationDialog}
        onClose={() => this.handleClose()}
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Deleting row`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {customDeleteObject ? customDeleteObject.message : ""}
          </DialogContentText>
          <Typography variant="caption" display="block" gutterBottom>
            {customDeleteObject ? customDeleteObject.additionalMessage : ""}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.handleClose()}>Cancel</Button>
          <Button onClick={() => this.handleOnConrimDelete()}>Yes</Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const {
      title,
      onAddDataChanged,
      onEditDataChanged,
      onDeleteataChanged,
      customDeleteObject,
    } = this.props;
    return (
      <React.Fragment>
        {this.renderConfirmDialog()}
        <MaterialTable
          icons={tableIcons}
          title={title}
          columns={this.state.columns}
          data={this.state.data}
          options={{ pageSize: 20 }}
          components={{
            Container: (props) => <Paper {...props} elevation={0} />,
            Toolbar: (props) => (
              <React.Fragment>
                <MTableToolbar {...props} />
                <Divider />
              </React.Fragment>
            ),
          }}
          editable={
            customDeleteObject
              ? {
                isEditable: (rowData) =>
                  rowData.field !== "access" &&
                  rowData.permissionType !== "manage",
                onRowAdd: (newData) =>
                  new Promise<void>((resolve) => {
                    setTimeout(() => {
                      resolve();
                      onAddDataChanged(newData);
                    }, 600);
                  }),
                onRowUpdate: (newData, oldData) =>
                  new Promise<void>((resolve) => {
                    setTimeout(() => {
                      resolve();
                      if (oldData) {
                        onEditDataChanged(newData, oldData);
                      }
                    }, 600);
                  }),
              }
              : {
                onRowAdd: (newData) =>
                  new Promise<void>((resolve) => {
                    setTimeout(() => {
                      resolve();
                      onAddDataChanged(newData);
                    }, 600);
                  }),
                onRowUpdate: (newData, oldData) =>
                  new Promise<void>((resolve) => {
                    setTimeout(() => {
                      resolve();
                      if (oldData) {
                        onEditDataChanged(newData, oldData);
                      }
                    }, 600);
                  }),
                onRowDelete: (oldData) =>
                  new Promise<void>((resolve) => {
                    setTimeout(() => {
                      resolve();
                      onDeleteataChanged(oldData);
                    }, 600);
                  }),
              }
          }
        />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(EditableTableComponent);
